<template>
  <el-select 
      v-model="partnerCode"
      placeholder="เลือกพาร์ทเนอร์"
      :loading="fatchingPartner"   
      filterable>
      <el-option
      v-for="partnerOption in partnerList"
      :key="partnerOption.partnerCode"
      :label="partnerOption.partnerName"
      :value="partnerOption.partnerCode"                
      >
      <span style="float: left">{{ partnerOption.partnerCode }}</span>
      <span
          style="
          float: right;
          color: var(--el-text-color-secondary);"
          >{{ partnerOption.partnerName }}</span
      >
      </el-option>
  </el-select>  
</template>

<script>

  import {Mutations, Actions} from '../store/enums/StoreEnums'

  export default {
    computed: {
      partnerList() {
        return this.$store.getters.getPartnerList
      },
      fatchingPartner() {
        return this.$store.getters.getFatchingStatus
      },
      partnerCode: {
        get() {
          return this.$store.getters.getRepresentId
        },
        set(val) {
          this.$store.dispatch(Actions.GET_PARTNER_BY_ID, val)
          if(!this.$route.params.basePartnerCode || this.$route.params.basePartnerCode == "")
          {            
            this.$router.replace({ name: "dashboard", params: { basePartnerCode: val}})
          }
          else
          {
            this.$router.replace({ name: this.$route.name, params: { basePartnerCode: val}})
          }
        }
      }
    },

    mounted() {
      console.log(this.$route)
      this.$store.dispatch(Actions.FETCH_PARTNER_LIST);

    },
    // methods: {
    //   onSelectPartnerHandler(val) {
        
    //   }
    // },
  }
</script>

